import * as React from 'react'
import classNames from 'classnames'

import CommentIcon from 'ui-component-library/icons/comment.svg'
import Link from 'content-components/_Primatives/Link'
import style from './style.scss'

type Props = {
  className?: string
  labelText: string
  count?: number
  url: string
  topicText?: string
}

function CommentToggleButton({
  url,
  className,
  count = 0,
  labelText,
  topicText,
}: Props) {
  return (
    <Link
      aria-label={`${topicText} ${labelText}`}
      className={classNames(style.wrapper, 'comment-icon-link', className)}
      url={url}
    >
      <CommentIcon className={style.commentBubble} />
      {count > 0 && <span className={style.count}>{count}</span>}
    </Link>
  )
}

export default CommentToggleButton
